import React, { useCallback } from "react";
import {
    Navbar,
    NavbarBrand,
    NavbarMenuToggle,
    NavbarMenuItem,
    NavbarMenu,
    NavbarContent,
    NavbarItem,
    Link,
    Image, 
} from "@nextui-org/react";
import logo from "../../assets/logo.png";
import TranslateComponent from "../Translate/TranslateComponent";
import {useTranslation} from "react-i18next";
import {useTheme} from "next-themes";
import ThemeSwitch from "../ThemeSwitch/ThemeSwitch"

export default function NavbarComponent() {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const {t} = useTranslation();
    const { theme, setTheme } = useTheme()

    
    const handleThemeChange = () => {
        setTheme(theme === "light" ? "dark" : "light");
    };
    
    const isActivePath = (path) => {
        return window.location.pathname === path;
    };
    
    const handleNavClick = useCallback((e) => {
        // İşlemler
    }, []);
    
    return (
        <Navbar
            className={"px-1 sm:px-5 py-3"}
            maxWidth={"full"}
            isBordered
            isMenuOpen={isMenuOpen}
            onMenuOpenChange={setIsMenuOpen}
        >
            <NavbarContent className="sm:hidden" justify="start">
                <NavbarMenuToggle aria-label={isMenuOpen ? "Close menu" : "Open menu"}/>
            </NavbarContent>

            <NavbarContent className="sm:hidden" justify="centers">
                <NavbarBrand className={"cursor-pointer"} >
                    <Image onClick={() => window.location.href = "/"}  width={130} height={100} src={logo} alt="logo"/>
                </NavbarBrand>
            </NavbarContent>

            <Image onClick={() => window.location.href = "/"} className={"hidden sm:flex"} width={190} height={100} src={logo}/>
                
            <NavbarContent className="hidden sm:flex gap-8 font-semibold w-full" justify="center">
                <NavbarItem isActive={isActivePath('/about')}>
                    <Link 
                        color={isActivePath('/about') ? "primary" : "foreground"} 
                        href="/about"
                        aria-label="Hakkımızda sayfasını görüntüle"
                        title="Hakkımızda"
                    >
                        {t("about")}
                    </Link>
                </NavbarItem>
                <NavbarItem isActive={isActivePath('/projects')}>
                    <Link 
                        color={isActivePath('/projects') ? "primary" : "foreground"}
                        href="/projects" 
                        aria-label="Projelerimizi görüntüle"
                        title="Projelerimiz"
                    >
                        {t("projects")}
                    </Link>
                </NavbarItem>
                <NavbarItem isActive={isActivePath('/references')}>
                    <Link 
                        color={isActivePath('/references') ? "primary" : "foreground"}
                        href="/references"
                        aria-label="Referanslarımızı görüntüle"
                        title="Referanslarımız"
                    >
                        {t("references.title")}
                    </Link>
                </NavbarItem>
                <NavbarItem isActive={isActivePath('/contact')}>
                    <Link 
                        color={isActivePath('/contact') ? "primary" : "foreground"}
                        href="/contact"
                        aria-label="İletişim sayfasını görüntüle"
                        title="İletişim"
                    >
                        {t("contact")}
                    </Link>
                </NavbarItem>
            </NavbarContent>

            <NavbarContent className="hidden sm:flex w-full" justify={"end"}>
                <NavbarItem className="w-full hidden sm:flex">
                    <TranslateComponent/>
                    <div className={"mx-5"}>
                        <ThemeSwitch 
                            isSelected={theme === "light"} 
                            onChange={handleThemeChange} 
                            />
                    </div>
                </NavbarItem>
            </NavbarContent>
            

            {/*mobile*/}
            <NavbarMenu>
                <NavbarMenuItem className={"mt-10"}>
                    <Link 
                        color={isActivePath('/about') ? "primary" : "foreground"}
                        href="/about"
                    >
                        {t("about")}
                    </Link>
                </NavbarMenuItem>

                <NavbarMenuItem className={"mt-6"}>
                    <Link 
                        color={isActivePath('/projects') ? "primary" : "foreground"}
                        href="/projects"
                    >
                        {t("projects")}
                    </Link>
                </NavbarMenuItem>

                <NavbarMenuItem className={"mt-6"}>
                    <Link 
                        color={isActivePath('/references') ? "primary" : "foreground"}
                        href="/references"
                    >
                        {t("references.title")}
                    </Link>
                </NavbarMenuItem>
                
                <NavbarMenuItem className={"mt-6"}>
                    <Link 
                        color={isActivePath('/contact') ? "primary" : "foreground"}
                        href="/contact"
                    >
                        {t("contact")}
                    </Link>
                </NavbarMenuItem>
                
                <NavbarMenuItem className={"mt-6"}>
                  <TranslateComponent/>
                  </NavbarMenuItem>
            </NavbarMenu>
            <NavbarContent className="flex sm:hidden " justify="end">

                <ThemeSwitch 
                    isSelected={theme === "light"} 
                    onChange={handleThemeChange} 
                    />
            </NavbarContent>
        </Navbar>
    );
}
